<template>
  <header :class="name === '/home'?'header':'header header_black'" :style="{boxShadow: height > 10 ? '0px 8px 8px 0px rgba(31,41,64,0.1)' : ''}">
    <div class="header_box">
      <img :src="name === '/home'?'./static/imgs/logo.svg':'../../../static/imgs/logo_white.svg'" @click="changeRouter('home')" class="header_logo" rel="Dropshipping Business" title="Dropshipping Business"/>
      <div class="header_box_right">
        <img :src="name === '/home'?'/static/imgs/more.svg':'/static/imgs/salesHomeback.png'" alt="" class="header_more" @click="isShowNav = true">
      </div>
    </div>
    <div :class="isShowNav ? 'header_nav header_nav_show' : 'header_nav header_nav_show1'">
      <div class="header_nav_bg" @click="isShowNav = false"></div>
      <div class="header_nav_box">
        <div class="header_nav_top">
          <div class="header_nav_close">
            <img src="../../assets/close.svg" alt="" @click="isShowNav = false" />
          </div>
          <div class="header_page">
            <div v-for="item in pageList" :key="item.name" :class="item.tab == true ? 'header_products' : 'header_text'"
              @click="item.tab == true ? '' : changeRouter(item.link)">
              {{item.tab == true ? '' : item.name}}
              <div class="products_tab" v-if="item.tab==true">
                <div class="header_products_top">
                  <div class="header_products_text" @click="changeRouter(item.link)">Products</div>
                  <div class="header_products_img" @click="showTab()">
                    <img class="header_products_img_button" src="../../assets/pull_down.svg">
                  </div>
                </div>
                <div v-if="showProductsFlag" class="header_subtext_box">
                  <div class="header_subtext_1" @click="changeRouter('/antdiy')">ANTDIY</div>
                  <div class="header_line"></div>
                  <div class="header_subtext_2" @click="changeRouter('/antsupply')">ANTSUPPLY</div>
                </div>
              </div>

              <div :class="`header_line header_line_${item.name}`" v-if="item.name!='Products'"></div>

            </div>
          </div>
          <div class="header_ad_button">
            <A-Button text='Get Started' @onclick="goLink(`https://apps.shopify.com/salesdish`)"></A-Button>
          </div>
        </div>
        <div class="header_nav_footer">
          <span v-for="item in footerList" :key="item.name" class="header_nav_footer_text"
            @click="item.name=='Free Trial'?goLink('https://apps.shopify.com/salesdish'):changeRouter(item.link, item.query)">
            {{item.name}}
          </span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: ['name', 'headerClickShow'],
  data () {
    return {
      showProductsFlag: false,
      pageList: [
        { name: 'Home', link: '/home' },
        { name: 'All Apps', link: '/allapps', tab: false },
        { name: 'Help Center', link: '/help' },
      ],
      nameList: ['/home', '/allapps', '/help'],
      footerList: [
        { name: 'All Apps', link: '/allapps' },
        { name: 'Privacy Policy', link: '/article?p=448' },
        { name: 'Help Center', link: '/help' },
        { name: 'Free Trial'},
        { name: 'Merchant Terms of Service', link: '/article?p=446'},
      ],
      isShowNav: false,
      height: 0,
      source: localStorage.getItem('ant_source') || ''
    }
  },
  methods: {
    changeRouter (link, type) {
      let query = {}
      if (type) {
        query = { p: type }
      }
      if (this.showProductsFlag) {
        this.showTab()
      }
      this.isShowNav = false
      this.$router.push({
        path: link,
        query
      }).catch(err => {
        console.log('e', err)
      })
    },
    goLink (url) {
      window.open(url)
    },
    handleScrollx () {
      this.height = window.pageYOffset
    },
    showTab () {
      this.showProductsFlag = !this.showProductsFlag;
      if (this.showProductsFlag) {
        document.querySelector('.header_products').style.height = "2.74rem"
        document.querySelector('.header_products_img_button').style.transform = "rotate(-180deg)"
      } else {
        document.querySelector('.header_products').style.height = "1.12rem"
        document.querySelector('.header_products_img_button').style.transform = "rotate(0deg)"
      }

    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScrollx, true)
  },
}
</script>

<style scoped>
.header_black{
  background: linear-gradient(180deg, #10075E 0%, #000000 100%)!important;
}
.click_for_deails {
  height: 0.6rem;
  background: #fb5821;
  text-align: center;
  font-size: 0.2rem;
  font-family: Helvetica-blod, Helvetica;
  font-weight: bold;
  color: #ffffff;
  line-height: 0.6rem;
  z-index: 999;
}
.click_for_deails > a {
  font-size: 0.2rem;
  font-family: Helvetica-blod, Helvetica;
  font-weight: bold;
  color: #ffffff;
  border-bottom: 0.01rem solid #ffffff;
}
.header {
  width: 100%;
  background: #fff;
  padding: 0.24rem 0 0.18rem;
  position: fixed;
  top: 0rem;
  z-index: 999;
}
.header_box {
  margin: 0 0.48rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_box_right {
  display: flex;
  align-items: center;
}
.header_box .header_logo {
  height: 0.72rem;
  width: 2.62rem;
  cursor: pointer;
  zoom: 0.88;
}
.header_box .header_more {
  /* float: right; */
  width: 0.4rem;
  height: 0.4rem;
  /* margin: 0.11rem 0 ; */
}
.header_sign {
  /* float: right; */
  margin: 0 0.38rem;
  font-weight: 500;
  color: #222536;
  font-family: Helvetica;
  border-radius: 8px;
  border: 1px solid #fc5322;
  font-size: 0.31rem;
  font-family: Helvetica;
  font-weight: 500;
  color: #fc5322;
  line-height: 0.54rem;
  padding: 0 0.15rem;
}
.header_nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto hidden;
  transform: translateX(100%);
}
.header_nav_show {
  transform: translateX(0);
}
.header_nav_show1 {
  transition: all 0.7s;
}
.header_nav .header_nav_bg {
  opacity: 0;
}
.header_nav_show .header_nav_bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.49;
  transition: all 0.7s;
}
.header_nav_box {
  position: absolute;
  top: 0;
  right: -5.68rem;
  bottom: 0;
  width: 5.68rem;
  /* margin-left: 1.75rem; */
  background: #fff;
  /* padding: 0 .46rem; */
  display: flex;
  flex-direction: column;
  transition: all 0.7s;
  overflow: auto;
  transform: translateX(100%);
}
.header_nav_show .header_nav_box {
  transform: translateX(0);
}

.header_nav_top {
  padding: .28rem 0 1.2rem 0.48rem;
}
.header_nav_close {
  text-align: right;
  padding-right: 0.48rem;
}
.header_nav_close img {
  width: 0.4rem;
  height: 0.4rem;
}
.header_page {
  margin: 0.01rem 0 0.7rem;
}
.header_page div:hover {
  color: #01C4C7;
}
.header_text {
  height: 1.12rem;
  font-size: 0.4rem;
  /* font-family: Helvetica; */
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222536;
  line-height: 1.12rem;
}
.header_subtext_box {
  height: 1.9rem;
}
.header_subtext_1 {
  height: 0.48rem;
  font-size: 0.34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(34, 37, 54, 0.6);
  line-height: 0.48rem;
  margin: 0.19rem 0 0.25rem;
}
.header_subtext_2 {
  height: 0.48rem;
  font-size: 0.34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(34, 37, 54, 0.6);
  line-height: 0.48rem;
  margin: 0.24rem 0 0.25rem;
}
.header_products {
  height: 1.12rem;
  font-size: 0.4rem;
  /* font-family: Helvetica; */
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222536;
  line-height: 1.12rem;
  transition: all 0.3s;
}
.header_products_top {
  display: flex;
  height: 1.03rem;
}
.header_products_text {
  margin-right: 0.2rem;
}
.header_products_img {
  flex: 1;
}
.header_products_img > img {
  transition: all 0.5s;
}
.header_products img {
  width: 0.24rem;
}
.header_line {
  width: 100%;
  height: 2px;
  background: #f6f7fa;
}

.header_ad_button {
  padding-right: 0.48rem;
}
.ad_button {
  width: 100%;
  text-align: center;
}
.header_nav_footer {
  background: #f6f7fa;
  padding: 1.32rem 0.46rem 0.46rem;
  flex: 1;
}
.header_nav_footer_text {
  display: block;
  font-size: 0.31rem;
  font-family: Helvetica;
  color: #222536;
  line-height: 0.31rem;
}
.header_nav_footer_text:hover {
  color: #01C4C7;
}
.header_nav_footer_text + .header_nav_footer_text {
  margin-top: 0.46rem;
}
.header_nav_show .header_nav_box {
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/mobileHeader.vue